import React, { useEffect, useState } from "react"
import { formatDuration } from "../utils/human-readable-duration-format"
export interface WaypointProps {
    dragRef?: any
    elementRef?: any
    isDragging: boolean; waypointName?: string; waypointAddress?: string; waypointComponent?: React.ReactNode
    waypointKey: string; stem?: boolean, stemDashed?: boolean,
    nextLeg?: {
        duration: number
        distance: number
    },
    
    tentativeDate?: string;
    onSetTentativeDate?: (value: string) => void

    onDeleteWaypoint?: () => void
}

export const Waypoint: React.FC<WaypointProps> = ({
    dragRef,
    elementRef,
    isDragging,
    waypointName, waypointAddress,
    children, waypointComponent,
    waypointKey, stem, stemDashed, nextLeg,
    onDeleteWaypoint,

    tentativeDate,
    onSetTentativeDate
}) => {
    const [isShowDate, setIsShowDate] = useState(!!tentativeDate);
    const [isActive, setIsActive] = useState(false);
    const [isHover, setIsHover] = useState(false);
    useEffect(() => {
        if(isDragging){
            setIsHover(false)
        }
    }, [isDragging])
    return <div
        className={"flex flex-row transition-opacity "+(isDragging ? 'opacity-50' : 'opacity-100')}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        ref={elementRef}
    >
        <div className="w-20 py-2" style={{opacity: isDragging ? 0 : 1}}>
            <div className={"cursor-move px-4 py-1 "+(dragRef && isHover ? 'opacity-100' : 'opacity-0')} ref={dragRef}>
                <i className="fa fa-grip-lines"></i>
            </div>
            {stem ? <div className="mt-4 mb-2 text-right small-copy">
                {nextLeg ? <div>{formatDuration(nextLeg.duration)}</div> : <div>&nbsp;</div>}
                {nextLeg ? <div>{Math.round(nextLeg.distance/1000).toLocaleString()}km</div> : <div>&nbsp;</div>}
            </div> : <div />}
        </div>
        {stem ? <div className="-mr-5 ml-5">
            <div className={"border-l-2 border-black h-full "+(stemDashed ? 'border-dashed' : '')} style={{marginRight: -1}}></div>
        </div> : null}
        <div className={"flex-1 flex flex-row"}>
            <div className="w-10 h-10 text-offwhite font-avant font-bold text-2xl flex items-center justify-center rounded-full bg-black">
                <div>{waypointKey}</div>
            </div>
            <div className="flex-1 pr-3">
                {children || waypointComponent || <div className="px-2">
                    <div className="font-bold">{waypointName}</div>
                    <div>{waypointAddress}</div>
                    {(isHover || tentativeDate || isActive) && <div className="small-copy pt-1">
                        {!isShowDate && onSetTentativeDate && <button className="underline" onClick={() => setIsShowDate(true)}>Add tentative date</button>}
                        {isShowDate && onSetTentativeDate && <input className="bg-transparent grayscale border border-black pl-1 small-copy" type="date" value={tentativeDate} min={new Date().toISOString().slice(0, 10)} onFocus={() => setIsActive(true)} onBlur={() => setIsActive(false)} onChange={(event) => onSetTentativeDate(event.target.value)} />}
                    </div>}
                </div>}
            </div>
            {onDeleteWaypoint && <button className={"w-10 h-10 text-black text-2xl flex items-center justify-center "+(isHover ? 'opacity-100' : 'opacity-0')} onClick={onDeleteWaypoint}>
                <i className="fal fa-times" />
            </button>}
        </div>
    </div>
}